import { Component, OnInit, Input } from '@angular/core';
import { Observable} from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserDashboardItem } from 'src/app/models/dashboard/user-dashboard-item';
import { ReturnUserDashboardItemResultPayload } from '../../models/dashboard/return-user-dashboard-item-result-payload';
import { ReturnMessage } from 'src/app/models/return-message';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { User } from 'src/app/models/user/user';
import { ReturnDashboardItemsPayload } from 'src/app/models/dashboard/return-dashboard-items-payload';
import { ReturnDashboardRecommendation } from 'src/app/models/recommendation/return-dashboard-recommendation';
import { Router } from '@angular/router';
import { ToastControllerWrapperService } from 'src/app/services/toast-controller-wrapper/toast-controller-wrapper.service';
import { ReturnDashboardQuote } from 'src/app/models/quote/return-dashboard-quote';
import { QuoteEditNavigationState } from 'src/app/models/quote/quote-edit-navigation-state';
import { UserAutocompleteDataLoaderService } from 'src/app/services/autocomplete-data-loader/user-autocomplete-data-loader.service';

@Component({
  selector: 'app-dashboard-user-item-summary',
  templateUrl: './dashboard-user-item-summary.component.html',
  styleUrls: ['./dashboard-user-item-summary.component.scss'],
})
export class DashboardUserItemSummaryComponent implements OnInit 
{
  @Input() loadOnInit: Boolean = false;
  @Input() user: User;

  itemsLoaded: boolean = false;
  dashboardItems: UserDashboardItem[] = null;

  constructor(
    private dashboardService: DashboardService,
    private userAutoCompleteDataLoaderService: UserAutocompleteDataLoaderService,
    private userData: UserDataService,
    private router: Router,
    private toastWrapper: ToastControllerWrapperService,
    public userAutoCompDataLoader: UserAutocompleteDataLoaderService
  ) 
  {
  }

  async ngOnInit() 
  {
    if (this.loadOnInit) 
    {
      this.loadDashboardItems();
      this.userData.getUser().then(u => this.user = u);
    }
  }

  loadDashboardItems() 
  {
    this.loadDashboardItemsObservable().subscribe();
  }

  loadDashboardItemsObservable() : Observable<ReturnMessage<ReturnDashboardItemsPayload>> 
  {
    if (this.dashboardItems && this.dashboardItems.length > 0)
    {
      this.dashboardItems.splice(0);
    }

    return this.dashboardService.getUserDashboardItems()
    .pipe(tap(response => 
      {
        if (response.success && response.payload.dashboardItems) 
        {
          this.itemsLoaded = true;
          this.dashboardItems = response.payload.dashboardItems.map(dashboardItem => ({dashboardItem: dashboardItem, result: null, userFilter: null}));
          this.dashboardItems = this.sortDashboardItems(this.dashboardItems);
          this.loadDashboardItemsResults();
        }
      }
    ));
  }

  loadDashboardItemsResults() 
  {
    if (this.dashboardItems && this.dashboardItems.length > 0)
    {
      this.dashboardItems.filter(dashboardItem => dashboardItem.dashboardItem.summarizationTypeId || dashboardItem.dashboardItem.isExpandable).forEach(
        dashboardItem => 
        {
          this.loadDashboardItemResultObservable(dashboardItem.dashboardItem.id).subscribe();
        }
      );
    }
  }

  loadDashboardItemResultObservable(dashboardItemId: number, filteredUserId: number = null): Observable<ReturnMessage<ReturnUserDashboardItemResultPayload>> 
  {
    return this.dashboardService.getUserDashboardItemResult(dashboardItemId, filteredUserId)
      .pipe(tap(response => {
        if (response.success && response.payload.userDashboardItemResult)
        {
          var item : UserDashboardItem;
          item = this.dashboardItems.find(dashboardItem => dashboardItem.dashboardItem.id == response.payload.userDashboardItemResult.id);
  
          if (item) 
          {
            item.result = response.payload.userDashboardItemResult;
          }
        }
      }));
  }

  filterDashboardItemResults(filteredDashboardItem: UserDashboardItem)
  {
    if (filteredDashboardItem.dashboardItem.isExpandable)
    {
      this.dashboardItems.find(dashboardItem => dashboardItem.dashboardItem.id == filteredDashboardItem.dashboardItem.id).result = null;

      var userFilterId : number = null;
      if (filteredDashboardItem?.userFilter?.id)
      {
        userFilterId = +filteredDashboardItem?.userFilter?.id;
      }

      this.loadDashboardItemResultObservable(filteredDashboardItem.dashboardItem.id, userFilterId).subscribe();
    }
  }

  sortDashboardItems(dashboardItems: UserDashboardItem[]): UserDashboardItem[] 
  {
    if (dashboardItems)
    {
      return dashboardItems.sort(function (item1, item2) 
      { 
        return +item1.dashboardItem.displayOrder - +item2.dashboardItem.displayOrder; 
      });
    }
  }

  goToRecommendation(recommendation: ReturnDashboardRecommendation) 
  {
    const customerAddressExists = recommendation.addressId !== null;

    if (customerAddressExists) {
      this.router.navigate(['recommendation', recommendation.id]);
    }
    else 
    {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }

  goToQuote(quote: ReturnDashboardQuote) 
  {
    const customerAddressExists = quote.addressId !== null;

    if (customerAddressExists) {
      this.router.navigate(['quote', quote.id], 
      {
        state: <QuoteEditNavigationState>{
          quoteId: quote.id,
          addressId: quote.addressId,
          addressType: quote.addressType
        }
      });
    }
    else
    {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }

  trackById(index: number, item: any): number 
  {
    return item.id;
  }

  getItemCardHeight() 
  {
    return 170;
  }
}
